import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EstimateConfigModel } from '@estimate';

@Component({
    selector: 'zero-estimate',
    templateUrl: './zero-estimate.component.html',
    styleUrls: ['./zero-estimate.component.scss'],
    standalone: false,
})
export class ZeroEstimateComponent {
    @Input() public estimate: EstimateConfigModel;
    @Input() message = 'zero_estimate_message';
    @Input() linkLabel = 'zero_estimate_contact_link_label';
    @Output() requestCall = new EventEmitter<void>();

    public onRequestCall(event: Event): void {
        event.preventDefault();
        this.requestCall.emit();
    }
}
